import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { TherapistAction } from 'src/redux/actions/constant';
import therapistService from 'src/services/apiServices/therapist-scheduling/therapistService';

const {
  THERAPIST_AUTO_MATCHING_FAILURE,
  THERAPIST_AUTO_MATCHING_REQUEST,
  THERAPIST_AUTO_MATCHING_LOADING,
  THERAPIST_AUTO_MATCHING_SUCCESS,

} = TherapistAction;

function* autoMatchingTherapists(action: any): SagaReturnType<any> {
  try {
    yield put({ type: THERAPIST_AUTO_MATCHING_LOADING });
    const response = yield call(therapistService.autoMatchinTherapistSerivce, action.payload);
    if (response?.status === 200) {
      yield put({
        type: THERAPIST_AUTO_MATCHING_SUCCESS,
        payload: response.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: THERAPIST_AUTO_MATCHING_FAILURE, payload: error });
  }
}

function* autoMatchingTherapistSaga() {
  yield takeEvery(THERAPIST_AUTO_MATCHING_REQUEST, autoMatchingTherapists);
}

export default autoMatchingTherapistSaga;
